<template>
    <div>
        <HeaderComponent />
<!--        <CoordinatorsComponent />-->
        <SectionsComponent />
        <AttendantsComponent />
    </div>
</template>

<script>
    import AttendantsComponent from '@/components/TeamPage/AttendantsComponent'
    import HeaderComponent from '@/components/TeamPage/HeaderComponent'
    // import CoordinatorsComponent from '@/components/TeamPage/CoordinatorsComponent'
    import SectionsComponent from '@/components/TeamPage/SectionsComponent'

    export default {
        name: 'Team',
        components: {
            AttendantsComponent,
            SectionsComponent,
            // CoordinatorsComponent,
            HeaderComponent
        }
    }
</script>

<style scoped>

</style>
